//
import { RTableHeaders } from '@/components/reusable_components/next'

//
export default RTableHeaders
  .from([
    {
      text: '#',
      value: 'id',
      width: '8%',
    },
    {
      text: 'numero',
      value: 'number',
      width: '8%',
    },
    {
      text: 'Cliente',
      value: 'sl_customer_business_name',
    },
    {
      text: 'Fecha de emisión',
      value: 'emission_date',
      align: 'right',
      format: 'date',
    },
    {
      text: 'Total',
      value: 'total',
      align: 'right',
      format: 'currency',
    },
  ])

  /**
   * { item_description }
   */
  .set('customer_detail', [
    {
      text: 'sucursal',
      value: 'sl_customer_branch_offices_address',
    },
    {
      text: 'folio',
      value: 'number',
    },
    {
      text: 'tipo referencia',
      value: 'typeDocument',
    },
    {
      text: 'folio referencia',
      value: 'numberRerefence',
    },
    {
      text: 'total',
      value: 'total',
      align: 'right',
      format: 'currency',
    },
    {
      text: 'emisión',
      value: 'emission_date',
      align: 'right',
      format: 'date',
    },
    {
      text: 'vencimiento',
      value: 'emission_date',
      align: 'right',
      format: 'date',
    },
    {
      text: 'usada',
      value: 'used_for_payment',
      align: 'center',
      format: 'boolean',
    },
  ])
